export default __webpack_public_path__ + "static/media/popup_UWO.1de3b099.png";